import { useEffect } from "react";
import { Network } from "@ionic-native/network";
import { TextZoom } from "@capacitor/text-zoom";
import { Capacitor } from "@capacitor/core";
import { AppMetricaProvider, AppMetricaConfigInterface } from "../providers/AppMetrica/AppMetrica";
import { history } from "../providers/Redux/Reducers/history";
import { useConfig } from "../providers/config";

const useAppInitialization = (
  setShowDisconnectedAlert: (show: boolean) => void,
  setShowConnectingAlert: (show: boolean) => void,
) => {
  const config = useConfig();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      TextZoom.set({ value: 1 });
    }

    // Internet connectivity monitoring
    let connectedToInternet = true;
    Network.onDisconnect().subscribe(() => {
      connectedToInternet = false;
      setShowDisconnectedAlert(true);
    });
    Network.onConnect().subscribe(() => {
      if (!connectedToInternet) {
        window.location.reload();
        setShowConnectingAlert(true);
      }
    });
  }, []);

  useEffect(() => {
    // Initialize AppMetrica if applicable
    if (
      config.appMetrica?.enabled &&
      Capacitor.isNativePlatform() &&
      config.appMetrica.apiKey &&
      !AppMetricaProvider.isActive
    ) {
      const configuration: AppMetricaConfigInterface = {
        apiKey: config.appMetrica.apiKey,
        sessionTimeout: 15,
        locationTracking: false,
      };

      AppMetricaProvider.initialize(configuration);
      history.listen((location) => {
        AppMetricaProvider.reportEvent(location.pathname);
      });
    }
  }, [config.appMetrica]);
};

export default useAppInitialization;
